import { useIntl } from "react-intl";

import { Button } from "@/components/Button";
import { IconLuggage } from "@/components/Icons";
import { RequiredLabel } from "@/features/flights/components/additional-services/RequiredLabel";
import { SelectedInfoBadge } from "@/features/flights/components/additional-services/SelectedInfoBadge";

type Props = {
  required?: boolean;
  selectedAmount?: number;
  onClick: () => void;
};

export const AddBaggageCard = ({
  required,
  selectedAmount,
  onClick,
}: Props) => {
  const intl = useIntl();

  return (
    <div className="relative flex flex-col rounded-3xl bg-white p-1">
      <div className="flex items-center gap-1 p-3">
        <IconLuggage className="size-18 shrink-0" />
        <div>
          <div className="font-medium text-text-primary">
            {intl.formatMessage({
              id: "travellers.addExtraBaggage",
              defaultMessage: "Add extra baggage",
            })}
          </div>
          <div className="mb-1 text-sm text-text-tertiary">
            {intl.formatMessage({
              id: "travellers.carryMore",
              defaultMessage:
                "Carry more of your essentials without leaving anything behind",
            })}
          </div>
          {selectedAmount && selectedAmount > 0 ? (
            <SelectedInfoBadge
              label={intl.formatMessage(
                {
                  id: "travellers.xExtraBaggagesSelected",
                  defaultMessage:
                    "{amount, plural, one {# Extra baggage} other {# Extra baggages}} selected",
                },
                { amount: selectedAmount },
              )}
            />
          ) : (
            <SelectedInfoBadge
              label={intl.formatMessage({
                id: "travellers.nothingSelected",
                defaultMessage: "Nothing selected",
              })}
              dimmed
            />
          )}
        </div>
      </div>
      <div className="p-3 pt-1">
        <Button variant="outlined" fullWidth onClick={onClick}>
          {selectedAmount && selectedAmount > 0
            ? intl.formatMessage({
                id: "travellers.editBaggageSelection",
                defaultMessage: "Edit baggage selection",
              })
            : intl.formatMessage({
                id: "travellers.addExtraBaggage",
                defaultMessage: "Add extra baggage",
              })}
        </Button>
      </div>
      {required ? <RequiredLabel /> : null}
    </div>
  );
};
